import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ConvertToString from "../../../../../components/Converter";
import PlusIcon from "../../../../../components/Icons/PlusIcon";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import {
  selectTeilsicherheitsbeiwertFuerErmuedung,
  setTeilsicherheitsbeiwertFuerErmuedung,
} from "../../../../../store/slices/innereSlice";

function TeilsicherheitsbeiwertFuerErmuedung({ showModal, show }) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const teilsicherheitsbeiwertFuerErmuedung = useSelector(
    selectTeilsicherheitsbeiwertFuerErmuedung
  );

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.partialSafetyFactor_2")}</p>}
      indicesValue={
        <span>
          &gamma;<sub>Mf</sub>
        </span>
      }
      formulaValue={
        <>
          <ToolTip
            id={"TeilsicherheitsbeiwertFuerErmuedung"}
            type={IconType.INFO}
            text={t("inner.fatigue.partialSafetyFactor_2_subText")}
          />
          <span className="input--formula" onClick={() => showModal(!show)}>
            <PlusIcon />
          </span>
        </>
      }
      inputValue={
        <select
          className="change-input"
          onChange={(e) => {
            dispatch(setTeilsicherheitsbeiwertFuerErmuedung(e.target.value));
          }}
          value={Number(teilsicherheitsbeiwertFuerErmuedung)}
        >
          <option value={1}>{ConvertToString("1", 2)}</option>
          <option value={1.15}>{ConvertToString("1.15", 2)}</option>
          <option value={1.35}>{ConvertToString("1.35", 2)}</option>
        </select>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default TeilsicherheitsbeiwertFuerErmuedung;
